<template>
    <el-dialog title="创建邀请" :visible="true" width="580px" :close-on-click-modal="false" :before-close="cancel">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="50px">
            <p class="sub-content-title">关联up主信息</p>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="UID" prop="mid">
                        <el-input class="set-width" size="small" :maxlength="12" v-model="item.mid" placeholder="请输入uid">
                            <i slot="suffix" class="el-input__icon el-icon-circle-close" @click="clear('mid')"></i>
                        </el-input>
                    </el-form-item>
                </el-col>
                <div class="nick-name">
                    <span>up主昵称</span>
                    <span v-if="item.nick">{{item.nick}}</span>
                    <span v-else>未输入uid</span>
                </div>
            </el-row>
            <p class="sub-content-title">小程序信息<span class="sub-title">小程序与up主关联成功后，支持自定义专属的头像和名称</span></p>
            <el-form-item label="头像" prop="logo">
                <avatar :size="40" :url="item.logo" :changable="true" @image-ok="changeLogo"></avatar>
            </el-form-item>
            <el-form-item label="昵称" prop="name">
                <el-input :maxlength="24" size="small" class="set-width" v-model="item.name" placeholder="请输入店铺名称，推荐4-12个字">
                    <i slot="suffix" class="el-input__icon el-icon-circle-close" @click="clear('name')"></i>
                </el-input>
            </el-form-item>
            <el-form-item label="介绍" prop="introduction">
                <el-input class="set-width textarea" type="textarea" :rows="4" placeholder="请输入小程序简介" v-model="item.introduction">
                    <i slot="suffix" class="el-input__icon el-icon-circle-close" @click="clear('introduction')"></i>
                </el-input>
            </el-form-item>
        </el-form>
        <div style="text-align: center; margin-top: 10px;">
            <btn info="取消" :type="1" @click="cancel"></btn>
            <btn info="确认" :type="0" @click="submitForm('ruleForm')" style="margin-left: 8px;"></btn>
        </div>
    </el-dialog>
</template>
<script>
    import Btn from '@/components/Button';
    import Avatar from '@/components/Avatar.vue';
    import dao from '@/lib/dao.js';
    export default {
        components: {
            Avatar,
            Btn
        },
        props: {
            logo: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            appPid: {
                type: String,
                default: 0
            },
            introduction: {
                type: String,
                default: ''
            }
        },
        data() {
            let vm = this;
            let midValidator = (rule, value, callback) => {
                let numReg = /^\d+$/;
                if (!numReg.test(value)) {
                    callback(new Error('请输入数字'));
                    return;
                }
                if (value) {
                    dao.shop.checkMid({
                        mid: vm.item.mid
                    }).then(data => {
                        vm.item.nick = data.nick;
                        callback();
                    }).catch(msg => {
                        callback(new Error(msg));
                    });
                } else {
                    callback(new Error('请输入uid'));
                }
            };
            let nameValidator = (rule, value, callback) => {
                if (vm.shopNameReg.test(value)) {
                    dao.shop.checkName({name: value, appId: vm.appPid}).then(data => {
                        callback();
                    }).catch(msg => {
                        callback(new Error(msg));
                    });
                } else {
                    callback(new Error('只能输入中文、英文和数字, 限4-24个字'));
                }
            };
            let introValidator = (rule, value, callback) => {
               !vm.item.introduction ? callback(new Error('请输入小程序简介')) : callback();
            }
            return {
                rules: {
                    mid: [
                        { validator: midValidator, trigger: 'blur' },
                    ],
                    name: [
                        { validator: nameValidator, trigger: 'blur'}
                    ],
                    introduction: [
                        { validator: introValidator, trigger: ['change', 'blur']}
                    ]
                },
                shopNameReg: new RegExp('^[\\u4e00-\\u9fa5_a-zA-Z0-9]{4,24}$'),
                shopStatus: false,
                item: {
                    logo: '',
                    nick: '',
                    name: '',
                    introduction: ''
                }
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$emit('save', this.item);
                    }
                });
            },
            cancel() {
                this.$emit('cancel');
            },
            clear(key) {
                this.item[key] = '';
            },
            changeLogo(url) {
                this.item.logo = url;
            }
        },
        mounted() {
            this.item.logo = this.logo;
            this.item.name = this.name;
            this.item.introduction = this.introduction;
        }
    }
</script>
<style lang="less" scoped>
.set-width {
    width: 200px;

    
}
.el-input__icon {
    cursor: pointer;
}
.el-dialog.el-dialog__footer {
    text-align: center;
}
.sub-content-title {
    line-height: 24px;
    height: 24px;
    color: #5C667E;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 20px;
    .sub-title {
        font-size: 12px;
        margin-left: 10px;
        font-weight: 400;
    }
}
.nick-name {
    font-size: 14px;
    display: inline-block;
    line-height: 40px;
    vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// src/components/NewInviteDialog.vue